import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconImageSvg } from './IconImageSvg';

export const IconImage: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconImageSvg} {...iconProps} />;
};
